// extracted by mini-css-extract-plugin
module.exports = {"syncBtn":"Subtitle_syncBtn__3k-Dy","mainTitle":"Subtitle_mainTitle__1KlMu"};